import Swiper from 'swiper/bundle';

export default class Grid {
    constructor() {
        if (window.themeGridInstance) return;
        window.themeGridInstance = this;
        this.init();
    }

    init() {
        document.body.addEventListener('click', (e) => {
            const item = e.target.closest('.gridder-list');
            if (!item) return;

            const container = item.closest('.gridder');
            if (!container) return;

            e.preventDefault();
            e.stopPropagation();

            const targetId = item.getAttribute('data-griddercontent');
            this.toggleContent(container, item, targetId);
        }, true);

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.closeActive();
        });
    }

    toggleContent(container, item, targetId) {
        const content = document.querySelector(targetId);
        if (!content) return;
        
        if (this.activeItem === item) {
            this.closeActive();
            return;
        }

        if (this.activeContent) {
            this.closeActive();
        }

        this.openContent(container, item, content);
    }

    openContent(container, item, content) {
        this.activeContainer = container;
        this.activeItem = item;
        this.activeContent = content;

        item.classList.add('is-active');
        content.classList.add('active');

        if (content.parentElement !== container) {
            container.appendChild(content);
        }

        this.positionContent(container, item, content);

        if (!content.querySelector('.gridder-close')) {
            const closeBtn = document.createElement('div');
            closeBtn.className = 'gridder-close';
            closeBtn.innerHTML = `<svg viewBox="0 0 40 40" width="30" height="30"><path d="M 10,10 L 30,30 M 30,10 L 10,30" stroke="#000" stroke-width="2" fill="none"/></svg>`;
            closeBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.closeActive();
            });
            content.prepend(closeBtn);
        }

        this.handleVideo(content);
        this.initSwiper(content);

        setTimeout(() => {
            const yOffset = -120;
            const y = content.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }, 150);
    }

    positionContent(container, item, content) {
        const gridColumns = window.getComputedStyle(container).getPropertyValue('grid-template-columns').trim().split(/\s+/);
        const gridColumnCount = gridColumns.length;

        const visibleItems = Array.from(container.children).filter(child => 
            child.classList.contains('gridder-list') && window.getComputedStyle(child).display !== 'none'
        );
        const index = visibleItems.indexOf(item);
        
        if (index === -1) return;

        const rowEndIndex = Math.min(
            Math.floor(index / gridColumnCount) * gridColumnCount + gridColumnCount - 1,
            visibleItems.length - 1
        );
        
        visibleItems[rowEndIndex].after(content);
    }

    closeActive() {
        if (!this.activeContent) return;

        this.activeItem.classList.remove('is-active');
        this.activeContent.classList.remove('active');
        
        const videoElement = this.activeContent.querySelector('video');
        if (videoElement) {
            videoElement.pause();
            videoElement.remove();
        }

        this.activeContent = null;
        this.activeItem = null;
    }

    handleVideo(content) {
        const videoHandler = content.querySelector('.videohandler');
        if (videoHandler) {
            const videoUrl = videoHandler.getAttribute('data-video');
            if (videoUrl) {
                const video = document.createElement('video');
                video.className = 'videoresponsive fcvideo';
                video.setAttribute('playsinline', '');
                video.setAttribute('controls', '');
                video.innerHTML = `<source src="${videoUrl}" type="video/mp4">`;
                videoHandler.innerHTML = '';
                videoHandler.appendChild(video);
                video.play();
            }
        }
    }

    initSwiper(content) {
        const sliderElement = content.querySelector('.swiper-container');
        if (sliderElement) {
            if (sliderElement.swiper) {
                sliderElement.swiper.update();
                return;
            }
            new Swiper(sliderElement, {
                slidesPerView: 1,
                loop: true,
                autoHeight: true,
                autoplay: { delay: 50000 },
                pagination: { el: sliderElement.querySelector('.swiper-pagination'), clickable: true },
                navigation: { 
                    nextEl: sliderElement.querySelector('.swiper-button-next'), 
                    prevEl: sliderElement.querySelector('.swiper-button-prev') 
                },
            });
        }
    }
}

new Grid();
